// extracted by mini-css-extract-plugin
export default {"headerImg":"EventHeader_headerImg__S5st5","headerImgSmall":"EventHeader_headerImgSmall__KeGVh"};